import type { MouseEvent } from 'react';

import {
  useIntent,
  useIntentWithResponse,
} from '../../../../core/hooks/intent.js';
import {
  type IntentProps,
  IntentWithoutResponseProps,
  IntentWithResponseProps,
} from '../../../../core/slots/Intent/Intent.js';
import { isIntentWithResponse } from '../../../../core/utils/is-intent-with-response.js';
import {
  getHandleSelect,
  getIntentIcon,
} from '../../../../navigation/menu/Intent.js';
import { getIntentSlots } from '../../../../navigation/menu/item-slots.js';
import { OverlayTooltip } from '../overlay-tooltip/OverlayTooltip.js';

const IntentWithoutResponse = (
  props: IntentWithoutResponseProps & { disabled?: boolean },
) => {
  const { onSelect, payload, options, children, disabled } = props;

  const intent = useIntent({
    payload,
    options,
  });

  const slots = getIntentSlots(children);

  const intentIcon = getIntentIcon(slots.prefix, intent.iconURL);
  const select = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    intent.send();
    onSelect?.(event);
  };

  return (
    <OverlayTooltip.Action
      label={slots.freeform}
      icon={intentIcon}
      onSelect={select}
      disabled={disabled}
    />
  );
};

const IntentWithResponse = (
  props: IntentWithResponseProps & { disabled?: boolean },
) => {
  const { onSelect, onResponse, payload, options, children, disabled } = props;

  const intent = useIntentWithResponse({
    payload,
    options,
  });

  const slots = getIntentSlots(children);

  const intentIcon = getIntentIcon(slots.prefix, intent.iconURL);

  const handleSelect = getHandleSelect(intent, onSelect, onResponse);

  return (
    <OverlayTooltip.Action
      label={slots.freeform}
      icon={intentIcon}
      onSelect={handleSelect}
      disabled={disabled}
    />
  );
};

export const Intent = (props: IntentProps) => {
  if (isIntentWithResponse(props)) {
    return <IntentWithResponse {...props} />;
  }
  return <IntentWithoutResponse {...props} />;
};
